import { render, staticRenderFns } from "./ComicCreator.vue?vue&type=template&id=547b4738&"
import script from "./ComicCreator.vue?vue&type=script&lang=js&"
export * from "./ComicCreator.vue?vue&type=script&lang=js&"
import style0 from "./ComicCreator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports